<mat-form-field appearance="outline" floatLabel="always" [class.loading]="loading$ | async">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="control" [required]="required">
        <mat-option *ngIf="loading$ | async" disabled>Loading...</mat-option>
        <mat-option *ngIf="!loading$ && states.length === 0" disabled>No licensed states available</mat-option>
        <mat-option *ngFor="let state of states" [value]="state.value">
            {{state.label}}
        </mat-option>
    </mat-select>
</mat-form-field>